export default "__VITE_ASSET__6dea86cc__"